import * as React from 'react'
import Dialog from '@material-ui/core/Dialog'
import { useAtom } from 'jotai'
import styled from 'styled-components'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { ChevronLeft } from '@geist-ui/react-icons'

import { FOLLOW_DIALOG_ACTIVE_TAB, followDialogActiveTabAtom } from '../../../atoms/profile'
import TabsContainer from '../../tabs/TabsContainer'
import FollowTabContent from './FollowTabContent'

// ========================== React component ==================================

interface Props {
  name: string
  address: string
  followingCount: number | undefined
  followersCount: number | undefined
  setFollowingCount: Function
}

const Name = styled.div`
  color: white;
  font-size: 28px;
  font-weight: 700;
  margin-left: 24px;

  // tablet
  @media (max-width: 62em) {
    font-size: 28px;
  }

  // mobile
  @media (max-width: 43em) {
    font-size: 20px;
  }
`

const Spacer = styled.div`
  height: 30px;
`

const FollowDialog = ({
  name,
  address,
  followersCount,
  followingCount,
  setFollowingCount,
}: Props): JSX.Element => {
  const [followDialogActiveTab, setFollowDialogActiveTab] = useAtom(followDialogActiveTabAtom)

  const fullscreen = useMediaQuery('(max-width: 43em)')
  const isTablet = useMediaQuery('(max-width: 62em)')

  return (
    <Dialog
      aria-labelledby="follow-dialog"
      open={followDialogActiveTab !== FOLLOW_DIALOG_ACTIVE_TAB.NONE}
      onClose={(): void => setFollowDialogActiveTab(FOLLOW_DIALOG_ACTIVE_TAB.NONE)}
      fullScreen={fullscreen}
      PaperProps={{
        style: {
          padding: isTablet ? 24 : 28,
          backgroundColor: '#101010',
          borderRadius: fullscreen ? 0 : 30,
          width: fullscreen ? '100vw' : '75vh',
          minWidth: fullscreen ? '100vw' : '75vh',
          minHeight: '40vh',
          height: fullscreen ? '100vh' : '80vh',
          margin: '0 !important',
          boxSizing: 'border-box',
        },
      }}
      BackdropProps={{
        style: {
          backdropFilter: 'blur(20px)',
        },
      }}
      disableEscapeKeyDown={false}
    >
      <OuterDiv>
        <CloseButton
          color="white"
          size={'35px'}
          onClick={() => setFollowDialogActiveTab(FOLLOW_DIALOG_ACTIVE_TAB.NONE)}
        />
        <Name>{name}</Name>
      </OuterDiv>
      <Spacer />
      <TabsContainer
        left
        small
        columns={[`${followingCount || 0} Following`, `${followersCount || 0} Followers`]}
        initialTab={followDialogActiveTab}
        tabCount={2}
      >
        {(index) => (
          <FollowTabContent
            address={address}
            followingCount={followingCount}
            setFollowingCount={setFollowingCount}
            currentIndex={index}
            index={0}
          />
        )}
        {(index) => (
          <FollowTabContent isForFollow address={address} currentIndex={index} index={1} />
        )}
      </TabsContainer>
    </Dialog>
  )
}

export default FollowDialog

// ========================== Styled components ================================

const OuterDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 15px;
`

const CloseButton = styled(ChevronLeft)`
  :hover {
    cursor: pointer;
  }
`
